import { Component } from '@angular/core';
import { ApplicationUser } from './../../../services/ApplicationUser';
import { Router } from '@angular/router';
import {PermissionsService} from "../../../services/permissions/permissions.service";
import {UsersService} from "../../../models/users/users.service";
import {CompaniesService} from "../../../models/companies/companies.service";
import {Roles, RoleTypes} from "../../../models/roles";
import {SocketService} from "../../../models/socket/socket.service";
import {ToasterService, Toast} from "angular2-toaster/angular2-toaster";
import {NotificationsModel, NotificationsType} from "../../../models/notifications/notifications.model";
import {NotificationsService} from "../../../models/notifications/notifications.service";
import {ClientStatusType} from "../../../models/clients/clients.type";
import {BadgesService} from "../../../models/badges/badges.service";
import {PricingsService} from '../../../models/pricings/pricings.service';

declare var jQuery:any;

@Component({
    selector: 'navigation',
    templateUrl: 'navigation.template.html'
})

export class NavigationComponent {
    user: Object = {};

    public switchUsers = [];

    public companies = [];

    private menuList = [
        {permission: 'dashboards.leads.view', link: '/leads', icon: 'fa fa-users', title: 'Leads'},
        {permission: 'dashboards.fs.view', link: '/funding-specialist', icon: 'fa fa-vcard', title: 'Funding Specialist'},
        {permission: 'dashboards.dataEntry.view', link: '/data-entry', icon: 'fa fa-file-o', title: 'DataEntry'},
        {permission: 'dashboards.underwriter.view', link: '/underwriter', icon: 'fa fa-files-o', title: 'Underwriter'},
        {permission: 'calculatorSettings.allow', link: '/calculator-settings', icon: 'fa fa-calculator', title: 'Calculator Settings'},
        {permission: 'dashboards.accounting.view', link: '/accounting', icon: 'fa fa-files-o', title: 'Accounting'},
        {permission: 'dashboards.users.view', link: '/users', icon: 'fa fa-user', title: 'Users'},
        {permission: 'permissionsByRole.manipulation', link: '/role', icon: 'fa fa-key', title: 'Role'},
//        {permission: 'dashboards.admins.view', link: '/admins', icon: 'fa fa-user-secret', title: 'Admins'},
        {permission: '', link: '/profile', icon: 'fa fa-user-secret', title: 'Profile'},
        {permission: 'crmSettings.allow', link: '/crm-settings', icon: 'fa fa-wrench', title: 'CRM Settings'}
    ];

    public permittedMenu;

    constructor (
        private router: Router,
        private toasterService: ToasterService,
        public permission: PermissionsService,
        public usersService: UsersService,
        public profile: ApplicationUser,
        public companiesService: CompaniesService,
        public rolesService: Roles,
        public socketService: SocketService,
        public badgesService: BadgesService
    ) {
        this.user = profile.UserManager.user;
    }



    ngOnInit() {

        this.getMenu();

        if(this.router.url == '/'){
            this.router.navigate([this.permittedMenu[0].link]);
        }

        this.companiesService.getList()
            .subscribe((res) => {
                this.companies = res.data;
            });

        this.usersService.getSwitchList()
            .subscribe((res) => {
                this.switchUsers = res.data;
            });


        let roleTabs = {
            [RoleTypes.FUNDING_SPECIALIST]: {
                [ClientStatusType.NEW_CLIENT]: '/funding-specialist/new-leads',
                [ClientStatusType.WAITING_ON_STATEMENT]: '/funding-specialist/waiting-on-statements',
                [ClientStatusType.STATEMENT_NOT_PRICED]: '/funding-specialist/not-priced',
                [ClientStatusType.STATEMENT_PRICED]: '/funding-specialist/priced',
                [ClientStatusType.AGREEMENT_OUT]: '/funding-specialist/agreement-out',
                [ClientStatusType.AGREEMENT_IN]: '/funding-specialist/agreement-in',
                [ClientStatusType.INCOMPLETE]: '/funding-specialist/incomplete'
            },
            [RoleTypes.DATA_ENTRY]: {
                [ClientStatusType.WAITING_ON_STATEMENT]: '/data-entry/waiting-on-statements',
                [ClientStatusType.AGREEMENT_IN]: '/data-entry/agreement-in',
                [ClientStatusType.INCOMPLETE]: '/data-entry/incomplete',
                [ClientStatusType.COMPLETE]: '/data-entry/complete'
            },
            [RoleTypes.UNDERWRITER]: {
                [ClientStatusType.APPROVED_NOT_FUNDED]: '/underwriter/approved',
                [ClientStatusType.INCOMPLETE]: '/underwriter/incomplete',
                [ClientStatusType.COMPLETE]: '/underwriter/complete'
            }
        };


        this.badgesService.onChange
            .subscribe((res: NotificationsModel) => {

                if (!res) return;

                if (this.badgesService.isChannelDisabled(res.badge.channel) && res.badge) return;

                let toast:Toast = {
                    timeout: 10000,
                    type: 'info',
                    body: res.message,
                    showCloseButton: true,
                    clickHandler: (t, isClosed):boolean => {
                        // got clicked and it was NOT the close button!
                        if (!isClosed) {
                            if ([
                                    NotificationsType.CLIENT_STATUS_CHANGED,
                                    NotificationsType.CLIENT_ASSIGNED,
                                    NotificationsType.CLIENT_REASSIGNED
                                ].indexOf(res.type) > -1) {

                                if (roleTabs[this.profile.user.role] && roleTabs[this.profile.user.role][res.data.status]) {
                                    let url = roleTabs[this.profile.user.role][res.data.status];
                                    this.router.navigateByUrl(url);
                                }
                            }

                            if (res.type === NotificationsType.SCHEDULED_CALLBACK_STARTS) {
                                this.router.navigateByUrl('/funding-specialist/scheduled-callbacks');
                            }
                        }

                        return true; // remove this toast !
                    }
                };

                this.toasterService.pop(toast);

            });

    }

    private getMenu() {
        let menu = [];
        for (let i = 0; i < this.menuList.length; i ++) {
            if(this.menuList[i].permission == "" || this.permission.can(this.menuList[i].permission)) {
                menu.push(this.menuList[i]);
            }
        }
        this.permittedMenu = menu;
    }

    getUsersByCompany(companyId) {

        let users = [];

        this.switchUsers.map((user) => {
            if (user.company_ids.indexOf(companyId) > -1) {
                users.push(user);
            }
        });

        return users;
    }


    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();
    }

    activeRoute(routename: string): boolean{
        return this.router.url.split('/')[1] === routename;
    }

    public switchUser(user) {
        this.profile.switchUser(user);

        return this.usersService.getOne(this.profile.user.id)
            .subscribe((res) => {
                this.profile.user = res.data;
                this.profile.UserManager.user = res.data;

                this.profile.UserManager.store();

                localStorage.setItem('originalUser', JSON.stringify(this.profile.originalUser));

                this.router.navigated = false;
                const config = this.router.config.map((route) => Object.assign({}, route));
                this.router.resetConfig(config);
                this.router.navigateByUrl(this.router.url);
            });

    }

    logout() {
       const user = ApplicationUser.getInstance();
       user.logout();
       this.router.navigate(['/login']);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/navigation/navigation.component.ts